export default "__VITE_ASSET__syFy8sax__"